/* istanbul ignore file */
// noinspection SpellCheckingInspection

export enum BlockType {
  /**
   * @deprecated ?
   */
  ARTICLE_TITLE = 'article__title',
  BYLINE = 'article__byline',
  ATTACHMENT = 'article__attachment',
  DATELINE = 'article__dateline',
  FORM = 'form',
  FRONTPAGE = 'frontpage__module',
  /**
   * @deprecated
   */
  BANNER = 'article__module', // article__module should never be added in admin 2, but should still be supported for old pages
  CARD_SEARCH = 'cardSearch',
  MAP_V2 = 'map_v2',
  MAP = 'map',

  QUOTE = 'article__quote',
  REFERENCES = 'article__references',
  RELATIONS = 'article__relations',
  WIDGET = 'flexible',
  TABLE = 'article__table',
  TEXT = 'article__bodytext',
  MEDIA = 'article__media',
  PROGRAM = 'article__program',
  AUDIO = 'article__audio',
  VIDEO = 'article__video',

  EMPLOYEES_AUTO = 'employees_auto',
  EMPLOYEES_MANUAL = 'employees_manual',
  EVENTS_AUTO = 'events_auto',
  EVENTS_MANUAL = 'events_manual',

  PAGE_LIST_AUTO = 'page_list_auto',
  PAGE_LIST_MANUAL = 'page_list_manual',
  DM_AUTO = 'dm_auto',
  DM_FILTER_SEARCH = 'dm_filter_search',
  DM_MANUAL = 'dm_manual',
  DM_SCHOOL = 'dm_school',
  DM_SINGLE = 'dm_single',
  /**
   * @deprecated ?
   */
  DIGITALT_MUSEUM = 'digitaltMuseum',

  KP = 'kp',
  KP_OWNER = 'kp_owner',
  /**
   * @deprecated ?
   */
  KULTUR_PUNKT = 'kulturpunkt',

  CARD = 'article__card',

  OPENING_HOURS = 'article__openinghours',
  /**
   * @deprecated ?
   */
  PERSON = 'article__person',
  /**
   * @deprecated
   */
  CALENDAR = 'calendar',
  /**
   * @deprecated ?
   */
  CALENDAR_NAVIGATOR = 'calendar__navigator',
  SEARCH = 'search',
  SHARING = 'article__sharing',

  TIMELINE = 'timeline',
  /**
   * @deprecated ?
   */
  PRODUCT_STATUS = 'productstatus',
  /**
   * @deprecated ?
   */
  TICKET = 'ticket',
  /**
   * @deprecated ?
   */
  TICKET_VALIDATION = 'ticket_validation',
  /**
   * @deprecated ?
   */
  /**
   * @deprecated ?
   */
  MEMBER = 'member',

  HEADER_MENU = 'menu', // settings block type
  FOOTER_ADDRESS = 'footer__address', // settings block type
  FOOTER_SOCIAL = 'footer__social', // settings block type
  FOOTER_INFO = 'footer__info', // settings block type
  FOOTER_MENU = 'footer__menu', // settings block type
}
